import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=44022cc6&scoped=true"
import script from "./Label.vue?vue&type=script&lang=ts"
export * from "./Label.vue?vue&type=script&lang=ts"
import style0 from "./Label.vue?vue&type=style&index=0&id=44022cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44022cc6",
  null
  
)

export default component.exports